var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProviderNoLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00a0df;}.cls-2{fill:#bfebff;}.cls-3{fill:#fff;}.cls-4{fill:#0072b2;}.cls-5{fill:none;stroke:#0072b2;stroke-linecap:round;stroke-linejoin:round;stroke-width:30px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "provider_no_logo"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 300,
    cy: 300,
    r: 300
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M317,276.29a94.64,94.64,0,0,1,48.35,13,95.82,95.82,0,0,1,35.36,35.36,94.63,94.63,0,0,1,13,48.35v30.31A34.48,34.48,0,0,1,379.05,438H125a34.5,34.5,0,0,1-34.64-34.64V373a94.63,94.63,0,0,1,13-48.35,95.84,95.84,0,0,1,35.37-35.36,94.64,94.64,0,0,1,48.35-13h12.27a125.94,125.94,0,0,0,105.37,0ZM252,253.2a91.61,91.61,0,0,1-46.55-12.27,89.76,89.76,0,0,1-33.55-33.56,94.44,94.44,0,0,1,0-93.1,89.84,89.84,0,0,1,33.55-33.56,94.5,94.5,0,0,1,93.1,0,89.86,89.86,0,0,1,33.56,33.56,94.44,94.44,0,0,1,0,93.1,89.79,89.79,0,0,1-33.56,33.56A91.58,91.58,0,0,1,252,253.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 395.59,
    cy: 361.94,
    r: 110.93,
    transform: "translate(-47.55 663.8) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M395.6,266a95.93,95.93,0,1,1-95.93,95.93A96,96,0,0,1,395.6,266m0-30A125.93,125.93,0,1,0,521.52,361.94,125.93,125.93,0,0,0,395.6,236Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "348 366.05 385.78 399 441.33 330.94"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderNoLogo);
export default __webpack_public_path__ + "static/media/provider_no_logo.8fef88c7e8c700151f352e0420cd2bd5.svg";
export { ForwardRef as ReactComponent };